import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';

import { Line as LineChartJS } from 'react-chartjs-2';
import { useMemo } from 'react';
import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    annotationPlugin
);

export default function Line({
    title,
    titleX,
    titleY,
    labels,
    datasets,
    className,
    annotations,
    xAxisType,
    options: optionsProp,
    plugins
}) {
    const options = useMemo(
        () => ({
            responsive: true,
            ...optionsProp,
            plugins: {
                legend: {
                    position: 'top',
                    ...optionsProp?.plugins?.legend
                },
                title: {
                    display: !!title,
                    text: title
                },
                annotation: {
                    annotations
                },
                ...optionsProp?.plugins
            },
            scales: {
                x: {
                    title: {
                        display: !!titleX,
                        text: titleX
                    },
                    type: xAxisType || 'linear',
                    offset: true,
                    ...optionsProp?.scales?.x
                },
                y: {
                    title: {
                        display: !!titleY,
                        text: titleY
                    },
                    ...optionsProp?.scales?.y
                }
            }
        }),
        [title, titleX, xAxisType, titleY, annotations, optionsProp]
    );

    return (
        <LineChartJS
            options={options}
            data={labels ? { labels, datasets } : { datasets }}
            style={{ width: '100%' }}
            className={className}
            plugins={plugins}
        />
    );
}
